var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 -960 960 960"}},[_c('path',{attrs:{"d":"M335-120v-60h86v-100H141q-24 0-42-18t-18-42v-440q0-24 18-42t42-18h680q24 0 42 \n        18t18 42v440q0 24-18 42t-42 18H541v100h86v60H335Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }